import React, { useMemo, useCallback } from 'react'
import t from '~t'
import { useDispatch, useSelector } from 'react-redux'
import { makeViewHide } from '~data/selectors/bookmarks'
import { makeCollection } from '~data/selectors/collections'
import { viewToggle, setListCoverRight } from '~data/actions/bookmarks'

import { Checkbox, Radio, Label } from '~ui'

export default function BookmarksHeaderViewShow({ spaceId = 0 }) {
    const dispatch = useDispatch()
    const getViewHide = useMemo(() => makeViewHide(), [])
    const getCollection = useMemo(() => makeCollection(), [])

    const view = useSelector(state => getCollection(state, spaceId).view)
    const viewHide = useSelector(state => getViewHide(state, spaceId)) || []
    const listCoverRight = useSelector(state => state.config.raindrops_list_cover_right)

    const onClick = useCallback(
        field => {
            dispatch(viewToggle(spaceId, field))
        },
        [dispatch, spaceId]
    )

    const onSetListCoverRight = useCallback(() => {
        dispatch(setListCoverRight(spaceId, !listCoverRight))
    }, [dispatch, spaceId, listCoverRight])

    const options = [
        ['cover', t.s(view == 'simple' ? 'icon' : 'cover')],
        ['title', t.s('title')],
        ['note', t.s('note')],
        ['excerpt', t.s('description')],
        ['highlights', t.s('highlights')],
        ['tags', t.s('tags')],
        ['info', t.s('bookmarkInfo')]
    ]

    return (
        <>
            <Label>{t.format('showInView', t.s('view_' + view))}</Label>

            <div>
                {options.map(([key, title]) => (
                    <Checkbox
                        key={key}
                        checked={!viewHide.includes(key)}
                        onChange={() => onClick(key)}>
                        {title}
                    </Checkbox>
                ))}
            </div>

            {view == 'list' && !viewHide.includes('cover') ? (
                <>
                    <Label>{t.s('coverPosition')}</Label>

                    <div>
                        <Radio
                            checked={!listCoverRight}
                            onChange={onSetListCoverRight}>
                            {t.s('left')}
                        </Radio>
                        <Radio
                            checked={listCoverRight}
                            onChange={onSetListCoverRight}>
                            {t.s('right')}
                        </Radio>
                    </div>
                </>
            ) : null}
        </>
    )
}
